<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
import HelloWorld from './components/HelloWorld.vue';
import LoginIframe from './views/LoginIframe.vue';
const isProduction = import.meta.env.MODE === 'production';
</script>

<template>
    <div>
        <RouterView />
        <LoginIframe />
        <component :is="'script'" v-if="isProduction" type="text/javascript">
            (function(c,l,a,r,i,t,y){ c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i; y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kfgsq4waxt");
        </component>
    </div>
</template>
